import { Link as Anchor } from 'react-router-dom'
import styled from 'styled-components'

export const Wrapper = styled.footer`
  width: 100%;
  flex-shrink: 0;
  background: rgba(255, 255, 255, 0.98);
  border-top: 1px solid rgba(40, 40, 40, 0.08);
  box-shadow: 0 -6px 24px rgba(30, 30, 30, 0.04);
`

export const Container = styled.div`
  width: min(1540px, calc(100% - 48px));
  margin: 0 auto;
  padding: 34px 0 18px;

  @media (max-width: 900px) {
    width: calc(100% - 28px);
  }

  @media (max-width: 520px) {
    width: calc(100% - 24px);
    padding: 24px 0 14px;
  }
`

export const Main = styled.div`
  display: grid;
  grid-template-columns: minmax(240px, 1.35fr) repeat(4, minmax(130px, 1fr));
  gap: 34px;
  align-items: start;

  @media (max-width: 1100px) {
    grid-template-columns: 1.4fr repeat(2, 1fr);
    row-gap: 30px;
  }

  @media (max-width: 680px) {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 18px 16px;

    .footer-brand,
    .footer-support,
    .footer-social {
      grid-column: 1 / -1;
    }
  }

  @media (max-width: 460px) {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 16px 14px;
  }
`

export const BrandBlock = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 12px;

  @media (max-width: 520px) {
    gap: 8px;
  }
`

export const BrandLink = styled(Anchor)`
  display: inline-flex;
  align-items: center;
`

export const Logo = styled.img`
  display: block;
  height: 54px;
  width: auto;
  object-fit: contain;

  @media (max-width: 520px) {
    height: 42px;
  }
`

export const BrandText = styled.p`
  max-width: 290px;
  margin: 0;
  color: #777777;
  font-size: 13px;
  line-height: 1.55;

  @media (max-width: 520px) {
    max-width: 100%;
    font-size: 12px;
    line-height: 1.45;
  }
`

export const Section = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 9px;

  @media (max-width: 520px) {
    gap: 6px;
  }
`

export const SectionTitle = styled.div`
  margin-bottom: 2px;
  color: #343434;
  font-size: 13px;
  font-weight: 700;
  letter-spacing: 0.05em;
  text-transform: uppercase;

  @media (max-width: 520px) {
    font-size: 11px;
  }
`

export const ItemText = styled.span`
  color: #686868;
  font-size: 14px;
  line-height: 1.35;
`

export const InternalLink = styled(Anchor)`
  color: #686868;
  font-size: 14px;
  line-height: 1.35;
  transition: color 0.2s ease;

  &:hover {
    color: #e90000;
  }

  @media (max-width: 520px) {
    font-size: 12px;
  }
`

export const ExternalLink = styled.a`
  color: #686868;
  font-size: 14px;
  line-height: 1.35;
  transition: color 0.2s ease;

  &:hover {
    color: #e90000;
  }

  @media (max-width: 520px) {
    font-size: 12px;
  }
`

export const SocialRow = styled.div`
  display: flex;
  align-items: center;
  gap: 9px;

  @media (max-width: 520px) {
    gap: 7px;
  }
`

export const SocialLink = styled.a`
  width: 38px;
  height: 38px;
  border-radius: 999px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: #f4f2ed;
  border: 1px solid rgba(40, 40, 40, 0.05);
  color: #3f3f3f;
  font-size: 17px;
  transition: all 0.2s ease;

  &:hover {
    color: #e90000;
    background: #ffffff;
    border-color: rgba(233, 0, 0, 0.16);
    box-shadow: 0 5px 16px rgba(30, 30, 30, 0.08);
    transform: translateY(-1px);
  }

  @media (max-width: 520px) {
    width: 34px;
    height: 34px;
    font-size: 15px;
  }
`

export const BottomBar = styled.div`
  margin-top: 30px;
  padding-top: 16px;
  border-top: 1px solid rgba(40, 40, 40, 0.07);
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  color: #999999;
  font-size: 12px;

  .mobile-copy {
    display: none;
  }

  @media (max-width: 520px) {
    margin-top: 18px;
    padding-top: 12px;
    justify-content: flex-start;
    gap: 0;
    font-size: 10px;

    .desktop-copy {
      display: none;
    }

    .mobile-copy {
      display: inline;
    }
  }
`
